export default "__VITE_ASSET__CmwuHnVq__"